import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import Pagination from "../../../components/Pagination";
import Table from "../../../components/table";
import usePagination from "../../../components/usePagination";
import api from "../../../api/api";
import * as bootstrap from "bootstrap";
import "../../Freight/Common/form.css";
import Breadcrumbs from "../../../components/Breadcrumbs";
import SearchIcon from "@mui/icons-material/Search";
  
const SalesBooking = () => {
  const location = useLocation();
  const { fromDate, toDate, createdBy } = location.state || {};

  console.log('SalesBooking - Received filters:', { fromDate, toDate, createdBy });
  
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  
  /* ================= FETCH CLIENTS ================= */
  useEffect(() => {
    const fetchClients = async () => {
      setLoading(true);
      console.log('Fetching bookings with params:', { fromDate, toDate, createdBy });
      try {
        const params = {};
        if (fromDate) params.fromDate = fromDate;
        if (toDate) params.toDate = toDate;
        if (createdBy) params.CreateBY = createdBy;
        console.log('API params:', params);

        const response = await api.get("/sales/confirmed-bookings", { params });
        console.log('API response:', response.data);

        const bookingsData = (response.data.bookings || []).map((c) => ({
          ...c,
          follow_up_number: parseInt(c.follow_up_number) || 0,
        }));

        setBookings(bookingsData);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch bookings");
      } finally {
        setLoading(false);
      }
    };
  
    fetchClients();
  }, [fromDate, toDate, createdBy]);
  
  /* ================= SEARCH FILTER ================= */
  const filteredBookings = bookings.filter((booking) => {
    const term = search.toLowerCase();

    return (
      booking.customer_name?.toLowerCase().includes(term) ||
      booking.company_name?.toLowerCase().includes(term)
    );
  });
  
  /* ================= PAGINATION ================= */
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(filteredBookings, 5);

  /* ================= TOOLTIP ================= */
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((el) => new bootstrap.Tooltip(el));
  }, [filteredBookings, currentPage]);
  
  if (error) return <p className="text-danger">{error}</p>;
  
  /* ================= TABLE COLUMNS ================= */
  const columns = [
    {
      label: "Customer Name",
      render: (booking) => (
        <span
          data-bs-toggle="tooltip"
          title={booking.customer_name}
        >
          {booking.customer_name}
        </span>
      ),
    },
    {
      label: "Company Name",
      render: (booking) => (
        <span data-bs-toggle="tooltip" title={booking.company_name}>
          {booking.company_name}
        </span>
      ),
    },
    {
      label: "Order Segment From",
      render: (booking) => (
        <span data-bs-toggle="tooltip" title={booking.order_segment_from}>
          {booking.order_segment_from}
        </span>
      ),
    },
    {
      label: "Order Segment To",
      render: (booking) => (
        <span data-bs-toggle="tooltip" title={booking.order_segment_to}>
          {booking.order_segment_to}
        </span>
      ),
    },
    {
      label: "Handled By",
      render: (booking) => (
        <span data-bs-toggle="tooltip" title={booking.handled_by}>
          {booking.handled_by || "-"}
        </span>
      ),
    },
    {
      label: "Date",
      render: (booking) => {
        // Parse the date string directly without timezone conversion
        const dateStr = booking.created_at.split('T')[0];
        const timePart = booking.created_at.split('T')[1]?.split('.')[0] || '';
        const [hours, minutes] = timePart.split(':') || [];
        const hour = parseInt(hours, 10);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        return `${dateStr} ${hour12}:${minutes} ${ampm}`;
      },
    },
  ];
  
  /* ================= RENDER ================= */
  return (
    <>
      <Breadcrumbs />
  
        {/* SEARCH INPUT */}
      <div className="mb-3 position-relative" style={{ maxWidth: "100%" }}>
        <input
          type="search"
          className="form-control ps-5"
          placeholder="Search by Client Name or Company Name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
 
        <SearchIcon
          style={{
            position: "absolute",
            left: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#6b7280",
            width:"16px",
            height:"16px"
          }}
        />
      </div>
  
      {/* TABLE */}
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No Booking Confirmed List found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};
  
export default SalesBooking;
